import { NavLink } from "react-router-dom";
import DownloadsList from "../components/downloadslist";
import DuctlineList from "../components/ductlinelist";
import { Container, Row, Col } from "react-bootstrap";

export default function Home() {
    return (
        <main>
            <Container>
                <Row>
                    <Col>
                        <h1>Home</h1>
                        <ul>
                            <li><NavLink to="/downloads">Downloads</NavLink></li>
                            <li><NavLink to="/ductlines">Ductlines</NavLink></li>
                        </ul>
                    </Col>
                </Row>
                <Row xs={1} lg={2} className="vcfh">
                    <Col>
                        <DownloadsList />
                    </Col>
                    <Col>
                        <DuctlineList />
                    </Col>
                </Row>
            </Container>
        </main>
    )
}
